import { Module } from "@/enums/modules";
export default {
  [Module.DASHBOARD]: {
    videoUrl: "https://www.youtube.com/embed/YH9-4IWkWNw"
  },
  [Module.POSITION_ALL_LOCATIONS]: {
    videoUrl: "https://www.youtube.com/embed/-6gX_91mtrI"
  },
  [Module.LOCATIONS_MANAGE]: {
    videoUrl: "https://www.youtube.com/embed/NpuBICZu46c"
  },
  [Module.POSTS]: {
    videoUrl: "https://www.youtube.com/embed/N2rLmbGCMrE"
  }
};
